import { CaptchaService } from './../captcha.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';

@Component({
  selector: 'app-recaptcha',
  templateUrl: './recaptcha.component.html',
  styleUrls: ['./recaptcha.component.css']
})
export class RecaptchaComponent implements OnInit {
  captchaResponse: string;
  captchaValid: boolean;

  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private captchaService: CaptchaService) {}

  ngOnInit() {}

  resolved($event) {
    this.captchaResponse = $event;
    this.captchaService
      .validate(this.captchaResponse)
      .subscribe((x: boolean) => {
        if (x) {
          this.captchaValid = x;
          this.notify.emit(x);
        }
      });
  }
}



// WEBPACK FOOTER //
// C:/Users/dtarc/source/repos/CODESENDER/web/src/app/recaptcha/recaptcha.component.ts